var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBroadcastActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.391,
    height: 23.242,
    viewBox: "0 0 19.391 23.242",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Broadcast_Active",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88341",
    "data-name": "Group 88341",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_142891",
    "data-name": "Path 142891",
    d: "M9.7,25.607a1.939,1.939,0,1,0,1.939,1.939A1.939,1.939,0,0,0,9.7,25.607Zm5.819,1.939a5.819,5.819,0,1,0-11.637,0,5.9,5.9,0,0,0,2.912,5.043L7.76,30.94a3.85,3.85,0,1,1,5.818-3.3,3.642,3.642,0,0,1-1.939,3.3l.969,1.649a5.9,5.9,0,0,0,2.906-5.044ZM9.7,17.85A9.726,9.726,0,0,0,0,27.54a9.54,9.54,0,0,0,4.849,8.342l.969-1.649A7.748,7.748,0,1,1,17.455,27.54a7.665,7.665,0,0,1-3.879,6.691l.969,1.648A9.657,9.657,0,0,0,9.7,17.85Z",
    transform: "translate(0 -17.85)",
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_142892",
    "data-name": "Path 142892",
    d: "M2-8H4.146V5.412H2Z",
    transform: "translate(6.584 17.83)",
    fill: "#262626"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcastActive);
export default __webpack_public_path__ + "static/media/broadcast_active.a608ed09.svg";
export { ForwardRef as ReactComponent };